import log from 'lib/log'
import { loadPublishedPosts, loadPublishedEvents } from 'state/actions/posts'
import { loadPublishedResponses } from 'state/actions/posts'

const loadPosts = async (profile, dispatch, getState, opts) => {
  try {
    await loadPublishedPosts({
      author: profile._id
    })(dispatch, getState, opts)
  } catch (err) {
    log.error(err)
  }
}

const loadEvents = async (profile, dispatch, getState, opts) => {
  try {
    await loadPublishedEvents({
      author: profile._id
    })(dispatch, getState, opts)
  } catch (err) {
    log.error(err)
  }
}

const loadResponses = async (profile, dispatch, getState, opts) => {
  try {
    await loadPublishedResponses({
      author: profile._id
    })(dispatch, getState, opts)
  } catch (err) {
    log.error(err)
  }
}

const prepareTertiaryContent = async (
  profile,
  place,
  dispatch,
  getState,
  opts
) => {
  switch (place) {
    case 'profile/public/events':
    case 'home/member/events':
      await loadEvents(profile, dispatch, getState, opts)
      break
    case 'profile/public':
    case 'profile/public/posts':
    case 'home/member/posts':
      await loadPosts(profile, dispatch, getState, opts)
      break
    case 'profile/public/responses':
    case 'home/member/responses':
      await loadResponses(profile, dispatch, getState, opts)
      break
    case 'profile/public/bio':
    case 'home/member/bio':
      break // should already have the data as it is part of the core profile
    default:
      log.error('todo: load tertiary content for ' + place)
  }
}

export default prepareTertiaryContent
